module.exports = __webpack_public_path__ + "img/channels.c8f75a42.png";